// Taken from Chakra: https://v2.chakra-ui.com/docs/styled-system/theme#z-index-values
export const zIndex = {
  hidden: "-1",
  base: "0",
  auto: "auto",
  dropdown: "1000",
  sticky: "1100",
  banner: "1200",
  overlay: "1300",
  modal: "1400",
  popover: "1500",
  skipLink: "1600",
  toast: "1700",
  tooltip: "1800",
};
